import { optionsMap } from 'pro-gallery-lib';
export const OVERLAY = {
  OVERLAY_ENABLED: 'controllers_behaviourParams_item_overlay_enabled',
  OVERLAY_TYPE: 'controllers_behaviourParams_item_overlay_overlayType',
  SIZE_IN_PIXEL: `controllers_behaviourParams_item_overlay_size_pixel`,
  SIZE_IN_PERCENT: `controllers_behaviourParams_item_overlay_size_percent`,
  HOVER_ANIMATION_BEHAVIOR: `controllers_behaviourParams_item_overlay_hoverAnimationBehavior`
};
function newInfoEnabledByUser(options) {
  return options.controllers_experimental_useNewInfo === 'true';
}
export const OVERLAY_CONTROLLERS = {
  [OVERLAY.OVERLAY_ENABLED]: (value, options) => {
    if (newInfoEnabledByUser(options)) {
      return {
        [optionsMap.behaviourParams.item.overlay.hoveringBehaviour]: value ? 'ALWAYS_SHOW' : 'NEVER_SHOW'
      };
    }
    return {};
  },
  [OVERLAY.OVERLAY_TYPE]: value => {
    if (value !== 'FULL') {
      return;
    }
    return {
      [optionsMap.behaviourParams.item.overlay.sizeUnits]: 'PERCENT',
      [optionsMap.behaviourParams.item.overlay.size]: 100,
      [optionsMap.behaviourParams.item.overlay.position]: 'BOTTOM',
      [optionsMap.behaviourParams.item.overlay.padding]: 0
    };
  },
  [OVERLAY.SIZE_IN_PIXEL]: (value, options) => {
    const unitSize = options[optionsMap.behaviourParams.item.overlay.sizeUnits];
    const type = options[OVERLAY.OVERLAY_TYPE];
    if (unitSize !== 'PIXEL' || type !== 'PARTIAL' || value === undefined) {
      return;
    }
    return {
      [optionsMap.behaviourParams.item.overlay.size]: value
    };
  },
  [OVERLAY.SIZE_IN_PERCENT]: (value, options) => {
    const unitSize = options[optionsMap.behaviourParams.item.overlay.sizeUnits];
    const type = options[OVERLAY.OVERLAY_TYPE];
    if (unitSize !== 'PERCENT' || type !== 'PARTIAL' || value === undefined) {
      return;
    }
    return {
      [optionsMap.behaviourParams.item.overlay.size]: value
    };
  }
};
//# sourceMappingURL=overlay.js.map